import { render, staticRenderFns } from "./BulksTable.vue?vue&type=template&id=1b44b319&"
import script from "./BulksTable.vue?vue&type=script&lang=js&"
export * from "./BulksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports